import React, { useEffect, useState, useRef, useContext } from 'react';
import axiosConn from '../../axiosConn';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useConfettiText } from '../../hooks/useConfettiText';
import { AuthContext } from '../../context/AuthContext';

const HuntProgressDisplay = ({ huntId }) => {
  const { player } = useContext(AuthContext);
  const [totalClues, setTotalClues] = useState(0);
  const [unlockedClues, setUnlockedClues] = useState(0);
  const [completedClues, setCompletedClues] = useState(0);
  const [justUnlocked, setJustUnlocked] = useState(false);
  const progressRef = useRef(null);

  const percent =
    totalClues > 0 ? Math.round((completedClues / totalClues) * 100) : 0;

  const [showConfettiText, ConfettiTextComponent] = useConfettiText(
    progressRef,
    false,
    '🎉 Progress Upgraded!',
    800,
    'huntProgress',
  );

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const res = await axiosConn.get(`/hunt-progress/${huntId}`, {
          headers: {
            Authorization: `Bearer ${player.token}`,
          },
        });
        const data = res.data.data.data;
        // console.log(res.data.data);
        // Use cluesUnlocked and cluesCompleted arrays from response
        const unlockedCount = Array.isArray(data.cluesUnlocked)
          ? data.cluesUnlocked.length
          : 0;
        const completedCount = Array.isArray(data.cluesCompleted)
          ? data.cluesCompleted.length
          : 0;
        const totalCluesCount = res.data.data.clueCount;

        // If completed clues increased, trigger confetti
        if (completedCount > completedClues && completedClues !== 0) {
          setJustUnlocked(true);
          showConfettiText();
          setTimeout(() => setJustUnlocked(false), 1200);
        }
        setTotalClues(totalCluesCount);
        setUnlockedClues(unlockedCount);
        setCompletedClues(completedCount);
      } catch (err) {
        console.error('Failed to load hunt progress', err);
      }
    };

    fetchProgress();
    // const interval = setInterval(fetchProgress, 30000);
    // return () => clearInterval(interval);
  }, [
    huntId,
    completedClues,
    // showConfettiText,
    player.token,
  ]);

  return (
    <div
      ref={progressRef}
      className="my-4 text-center"
      style={{
        position: 'relative',
        background: 'linear-gradient(90deg, #f59e42 0%, #10b981 100%)',
        borderRadius: 18,
        padding: '24px 12px',
        boxShadow: '0 4px 24px #f59e4222',
        color: '#fff',
        overflow: 'hidden',
        maxWidth: 420,
        margin: '32px auto',
        animation: justUnlocked ? 'pop 0.7s' : undefined,
      }}
    >
      <h5 style={{ fontWeight: 700, fontSize: 22, letterSpacing: 1 }}>
        <span role="img" aria-label="trophy">
          🏆
        </span>{' '}
        Your Progress
      </h5>
      <p style={{ fontSize: 18, marginBottom: 8 }}>
        <span role="img" aria-label="key">
          🗝️
        </span>{' '}
        {unlockedClues} clues unlocked
        <span style={{ marginLeft: 8, fontWeight: 600 }}>
          |{' '}
          <span role="img" aria-label="check">
            ✅
          </span>{' '}
          {completedClues} completed
        </span>
        <span style={{ marginLeft: 8, fontWeight: 600 }}>({percent}%)</span>
      </p>
      <ProgressBar
        now={percent}
        label={`${percent}%`}
        style={{
          height: '24px',
          fontWeight: 700,
          fontSize: 16,
          background: '#fff',
          color: '#16a34a',
          borderRadius: 12,
          boxShadow: '0 2px 8px #10b98122',
        }}
        animated
        variant={percent === 100 ? 'success' : 'warning'}
      />
      {percent === 100 && (
        <div
          style={{
            fontSize: 24,
            marginTop: 16,
            color: '#16a34a',
            fontWeight: 700,
            animation: 'pop 0.7s',
          }}
        >
          <span role="img" aria-label="party">
            🎉
          </span>{' '}
          Hunt Complete!
        </div>
      )}
      <ConfettiTextComponent />
      <style>
        {`
          @keyframes pop {
            0% { transform: scale(0.7); opacity: 0; }
            60% { transform: scale(1.2); opacity: 1; }
            100% { transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
};

export default HuntProgressDisplay;
